import { Patient } from './patient';
export class Hospital {
    hospital_id: number;
    name: string;
    short_name?: string;
    patients?: Patient[];
}
